/**
 * API Configuration
 * SECURITY: These keys are safe to expose in client-side code
 *
 * Supabase Anon Key: Protected by Row Level Security (RLS)
 * Paddle Client Token: Public token for checkout only
 *
 * IMPORTANT: Replace with YOUR actual keys before deployment
 */

export const API_CONFIG = {
  // Supabase Configuration
  supabase: {
    url: 'https://dsxhggwsxycvenlrhczy.supabase.co',  // Replace with your Supabase URL
    anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRzeGhnZ3dzeHljdmVubHJoY3p5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM3MTgxMTksImV4cCI6MjA3OTI5NDExOX0.D4Qr8iSRokLjouana1pi9TREOs8x-slVYdQGvXBrYuw',  // Replace with your anon key

    // NEVER expose service role key in client code
    // Service role key should ONLY be in Supabase Edge Functions (server-side)
  },

  // Paddle Payment Configuration
  paddle: {
    environment: 'sandbox',  // Change to 'production' when going live
    clientToken: 'test_50bbf40fcebc01faef82a5d289b',  // Replace with your Paddle client token

    // Price IDs for each subscription tier
    priceIds: {
      starter_monthly: 'pri_01kak0x63g60bnvdbmaet6akf9',      // Replace with your Starter Monthly price ID
      starter_annual: 'pri_01kak0zf4tm3ez79whep50xxnv',       // Replace with your Starter Annual price ID
      professional_monthly: 'pri_01kak11fqgb0dhzt9w981edvxs', // Replace with your Professional Monthly price ID
      professional_annual: 'pri_01kak138szmw9ryahqhhk2bnst',  // Replace with your Professional Annual price ID
      lifetime: 'pri_01kak14wb6xj02020khsf0fxsh'              // Replace with your Lifetime price ID
    }
  },

  // PayPal Payment Configuration
  paypal: {
    environment: 'sandbox',  // Change to 'live' when going live
    clientId: 'Ab_1CexhdrbMLjPWkYwv6UjMxrgGnYgqDTwXbCgad3nLYbQJBhgW0BZwzuFp7U44QJRg0ugnBBy6DxCG',  // Replace with your PayPal Client ID

    // Plan IDs for subscriptions (create these in PayPal dashboard)
    planIds: {
      starter_monthly: 'P-5390907546151740NNETMISY',
      starter_annual: 'P-94D75843FJ601222KNETMISY',
      professional_monthly: 'P-09C87667N3750960XNETMISY',
      professional_annual: 'P-5RX89873JY140772ENETMITA'
    },

    // One-time payment amounts for lifetime (in USD)
    oneTimePayments: {
      lifetime: 99.00
    }
  },

  // Gumroad Payment Configuration
  gumroad: {
    // Product URLs for each tier (create these on gumroad.com)
    productUrls: {
      starter_monthly: 'https://8357075536232.gumroad.com/l/nrnxbp',      // Starter Monthly
      starter_annual: 'https://8357075536232.gumroad.com/l/wesqz',        // Replace with your Starter Annual URL
      professional_monthly: 'https://8357075536232.gumroad.com/l/dlvin', // Replace with your Professional Monthly URL
      professional_annual: 'https://8357075536232.gumroad.com/l/fkcqk',  // Replace with your Professional Annual URL
      lifetime: 'https://8357075536232.gumroad.com/l/klhqor'              // Replace with your Lifetime URL
    }
  },

  // Supabase Edge Functions (Secure API Proxies)
  edgeFunctions: {
    // Gemini API proxy - keeps your API key secure on server
    generateResume: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/generate-resume',
    generateJobMatchedCV: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/generate-job-cv',
    generateLinkedInProfile: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/generate-linkedin-profile',
    generateCoverLetter: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/generate-cover-letter',
    // Free scoring features
    atsScore: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/ats-score',
    'linkedin-profile-score': 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/linkedin-profile-score',
    // Paddle checkout creator
    createCheckout: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/create-paddle-checkout',
    // Paddle webhook handler
    paddleWebhook: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/paddle-webhook',
    // PayPal checkout creator (one-time payments)
    createPayPalOrder: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/create-paypal-order',
    // PayPal subscription creator (recurring payments)
    createPayPalSubscription: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/create-paypal-subscription',
    // PayPal order capture
    capturePayPalOrder: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/capture-paypal-order',
    // PayPal webhook handler
    paypalWebhook: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/paypal-webhook',
    // Gumroad webhook handler
    gumroadWebhook: 'https://dsxhggwsxycvenlrhczy.supabase.co/functions/v1/gumroad-webhook'
  }
};

/**
 * Security Notes:
 *
 * ✅ SAFE TO EXPOSE:
 * - Supabase URL and Anon Key (protected by RLS policies)
 * - Paddle Client Token (public, only for checkout)
 * - Paddle Price IDs (just product identifiers)
 * - Edge Function URLs (protected by authentication)
 *
 * ❌ NEVER EXPOSE IN CLIENT CODE:
 * - Supabase Service Role Key (only in Edge Functions)
 * - Gemini API Key (only in Edge Functions)
 * - Paddle Secret Key (only in Edge Functions)
 *
 * 🔒 SECURITY MEASURES:
 * 1. Row Level Security (RLS) on Supabase tables
 * 2. API calls proxied through Supabase Edge Functions
 * 3. Rate limiting based on subscription tier
 * 4. Authentication required for all API calls
 * 5. Usage tracking to prevent abuse
 */

// Validate configuration on import
if (API_CONFIG.supabase.url === 'https://your-project.supabase.co') {
  console.warn('⚠️ [API Config] Using default Supabase URL - please update config/api-keys.js with your actual keys');
}

if (API_CONFIG.paddle.clientToken === 'test_...') {
  console.warn('⚠️ [API Config] Using default Paddle token - please update config/api-keys.js with your actual keys');
}

export default API_CONFIG;
